import { Stack } from "@mui/material";
import { ImageNotFound, TextNoData } from "./component";

const NoResultsOverlay = () => {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      <ImageNotFound />
      <TextNoData>Not Found</TextNoData>
    </Stack>
  );
};

export default NoResultsOverlay;
